// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-setting .user-info{margin-bottom:20px}.account-setting .user-info .van-field__control{text-align:right}.account-setting .user-info .van-cell{padding:10px 30px}.account-setting .user-info .van-cell__title{text-align:left}", ""]);
// Exports
module.exports = exports;
